import { Spinner } from '@phosphor-icons/react';

export const PageLoadingSkeleton = () => (
  <div
    className="min-h-[60vh] flex items-center justify-center text-muted-foreground"
    data-testid="page-loading-skeleton"
    role="status"
    aria-live="polite"
  >
    <div className="flex items-center gap-3">
      <Spinner size={20} className="animate-spin text-secondary" />
      <span className="text-sm">Loading…</span>
    </div>
  </div>
);
